import { ALL_FEATURES } from './types.js';
/**
 * Catalog of paid SKUs. Subscription-only at launch — the one-time SKUs
 * (deep_reading / natal_chart_full / compat_full / deep_forecast) were
 * dropped 2026-05-15. Their entitlement code path still exists; we just no
 * longer sell them. The shared monthly subscription unlocks ALL_FEATURES.
 *
 * Treat this object as read-only at runtime — backend, frontend, and payment
 * providers all import it as the contract between them.
 */
export const SKU_CATALOG = {
    sub_monthly: {
        id: 'sub_monthly',
        kind: 'subscription',
        period: 'monthly',
        priceRub: 399,
        priceStars: 300,
        grants: ALL_FEATURES,
        titleRu: 'Premium · месяц',
        titleEn: 'Premium · month',
        descriptionRu: 'Личный гороскоп на сегодня, чат «Спроси Ядвигу», все расклады без лимита, полная натальная карта, недельный прогноз и совместимость',
        descriptionEn: 'Personal daily reading, "Ask Yadviga" chat, all spreads unlimited, full natal chart, weekly forecast, compatibility',
    },
    // Yearly — kept in the catalog (disabled in paywall) so the price has a
    // home. 15% off the 12-month total: 12 × 300⭐ = 3600 → 3060, 12 × 399₽ =
    // 4788 → 4070. Owner cap: yearly discount must NOT exceed 15% because
    // locking in 12 months of AI cost at a deeper discount is risky pre-launch
    // (a single abuser hitting DAILY_TOKEN_CAP costs ~$180/yr).
    sub_yearly: {
        id: 'sub_yearly',
        kind: 'subscription',
        period: 'yearly',
        priceRub: 4070,
        priceStars: 3060,
        grants: ALL_FEATURES,
        titleRu: 'Premium · год',
        titleEn: 'Premium · year',
        descriptionRu: 'То же что месячный план, со скидкой −15%',
        descriptionEn: 'Same as monthly, with −15% off',
        disabled: true,
    },
};
export function getSku(id) {
    return SKU_CATALOG[id];
}
export const SUBSCRIPTION_SKUS = (Object.values(SKU_CATALOG)
    .filter((s) => s.kind === 'subscription')
    .map((s) => s.id));
export const ONE_TIME_SKUS = (Object.values(SKU_CATALOG)
    .filter((s) => s.kind === 'one_time')
    .map((s) => s.id));
//# sourceMappingURL=sku.js.map